module.exports = __webpack_public_path__ + "img/s5_stepimg03-s.c6f2204d.png";